import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ConfirmationModal from "./ConfirmationModal";
import * as actions from "../../actions/users/getUserActions";
import { bindActionCreators } from "redux";
import { Dimmer, Modal, Loader, Menu, Icon, Header, Button, Grid } from "semantic-ui-react";
import { HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.full.css";
import { colWidths } from "../../Constants/xrefColWidths";
import { colHeaders } from "../../Constants/xrefColHeaders";
import { filterEnabledCols } from "../.././Constants/xrefFilterEnabledCols";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";
import * as ccr from "../../Common/Utility/customCellRender";

try {

    var userDetails = atob(localStorage.getItem("userDetails"));
    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}
var FIRM_ID = null;
FIRM_ID = userDetails.UserContext.firmId;

class StaffLinkPageActions extends Component {
    filterUserStatus = true;

    constructor(props) {
        super(props);

        String.prototype.replaceAll = function (search, replacement) {
            var target = this;
            return target.split(search).join(replacement);
        };

        this.validationNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
            showCloseAllBtn: true
        };

        this.hotTableComponent = React.createRef();
        this.state = {
            selectedRows: [],
            selectedUsersCount: 0,
            changedRows: [],
            showLicenseError: false,
            activatedUsersList: [],
            showPopup: false,
            disableCompletebutton: false
        };

        this.settings = {
            licenseKey: "0b014-a057a-62a00-d4631-40c07",
            rowHeaders: true,
            className: "htLeft",
            fillHandle: {
                direction: "vertical",
                autoInsertRow: false
            },

            fixedColumnsLeft: 6,
            columnSorting: true,
            multiColumnSorting: false,
            manualColumnResize: true,
            manualRowResize: true,
            filters: filterEnabledCols,
            dropdownMenu: ["filter_action_bar", "filter_by_value"],
            observeDOMVisibility: true,
            observeChanges: true,
            stretchH: "all",
            manualColumnMove: true,
            cells: this.cells.bind(this),
            headerTooltips: {
                rows: false,
                columns: true,
                onlyTrimmed: false
            }
        };

        this.columns = [
            {
                data: "firstName",
                allowEmpty: false,
                allowInvalid: true,
                renderer: ccr.firstnameRender.bind(this)
            },

            {
                data: "middleName"
            },
            {
                data: "lastName",
                allowEmpty: false,
                allowInvalid: false
            },
            {
                data: "email",
                allowEmpty: false,
                allowInvalid: false
            },
            {
                data: "userStatus",
                allowEmpty: true,
                allowInvalid: false
            }
        ];
    }

    afterOnCellMouseDownHandler(event, cellCoords, TD) {
        if (
            !this.hotTableComponent ||
            !this.hotTableComponent.current ||
            !this.hotTableComponent.current.hotInstance
        ) {
            return;
        }
    }
    cells(row, col, prop) {

        const cellProperties = {};
        if (this.props.isEdited) {
            if (col === 0) {
                cellProperties.readOnly = true;

            } else {
                cellProperties.readOnly = false;
            }
        }
        return cellProperties;
    }


    exportToExcel() {

    }

    handleClearFilters() {
        if (this.hotTableComponent.current === null) return;
        const hot = this.hotTableComponent.current.hotInstance;
        var filterPlugin = hot.getPlugin("Filters");
        filterPlugin.clearConditions();
        filterPlugin.filter();
        this.props.actions.clearAllFilters(false, this.props.staffReportDetails);
    }

    sortSelectedUsersToTop() {
        if (this.hotTableComponent.current === null) return;
        const hot = this.hotTableComponent.current.hotInstance;
        var filterPlugin = hot.getPlugin("Filters");
        filterPlugin.clearConditions();
        filterPlugin.filter();
    }

    uniqueValidator(value, callback, oldValue) {
        var emailIds = this.props.allUsers.map(elem => elem.email_id.toUpperCase());
        var index = emailIds.indexOf(oldValue.toUpperCase());
        emailIds.splice(index, 1, oldValue);
        if (emailIds.includes(value.toUpperCase())) {
            value = oldValue;
        }
        return value;
    }

    afterChangeHandler(changes, source) {
        if (
            changes === null ||
            this.hotTableComponent.current === null ||
            source === "loadData"
        )
            return;
        let hot = this.hotTableComponent.current.hotInstance;

        hot.render();
    }

    afterLoadDataHandler(initialLoad) {
        if (
            !this.props.allUsers.length ||
            this.hotTableComponent.current === null
        ) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        if (this.filterUserStatus) {
            var filterPlugin = hot.getPlugin("Filters");
            filterPlugin.addCondition(10, "by_value", [["Active"]]);
            filterPlugin.filter();
        }
    }

    afterFilterHandler(conditionsStack) {
        if (this.hotTableComponent.current === null) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        let afterFilterRowsCount = hot.getData().length;
        this.props.actions.getRowsCountAfterFilter(afterFilterRowsCount);
        this.filterUserStatus = false;
    }
    nameValidation(changes, type) {
        // empty validation - replaces to old value incase empty
        let actualLabel = type === "firstName" ? "First name" : "Last name ";
        if (
            (type === "firstName" || type === "lastName") &&
            changes[0][3] == ""
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should not be empty`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
        // length & special characters validation - replaces to old value incase invalid entry
        if (changes[0][3].length > 50) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should not contain more than 50 characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }

        if (
            changes[0][3] &&
            /[^\u0000-\u007F]/.test(changes[0][3])
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should not contain latin special characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    initialValidation(changes, type) {
        // length & special characters validation - replaces to old value incase invalid entry
        if (changes[0][3].length > 60) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Middle name should not contain more than 60 characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }


        if (
            changes[0][3] &&
            /[^\u0000-\u007F]/.test(changes[0][3])
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Middle name should not contain latin special characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }

    emailValidation(changes, type) {
        // empty validation - replaces to old value incase empty
        if (type === "email" && changes[0][3] == "") {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Email should not be empty`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
        // length & special characters validation - replaces to old value incase invalid entry
        if (
            !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                changes[0][3]
            )
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Invalid email Id`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }

    onBeforeHotChange(changes, source) {
        if (
            (source !== "edit" && !changes) ||
            this.hotTableComponent.current === null
        ) {
            return;
        }

        if (
            (source === "edit" || source === "Autofill.fill")
        ) {
            changes[0][3] = changes[0][3].replace(/  +/g, ' ');
        }
        switch (changes[0][1]) {
            case "firstName":
            case "lastName":
                this.nameValidation(changes, changes[0][1]);
                break;
            case "middleName":
                this.initialValidation(changes, changes[0][1]);
                break;
            case "email":
                this.emailValidation(changes, changes[0][1]);
                break;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        if (
            source === "Autofill.fill" &&
            (changes[0][1] === "firstName" ||
                changes[0][1] === "lastName" ||
                changes[0][1] === "middleName" ||
                changes[0][1] === "email")
        ) {
            return false;
        }

        if (source === "edit" && changes[0][1] === "email") {
            changes.map(change => {
                let col = hot.propToCol(change[1]);
                let row = change[0];
                let changed = change[3];
                changed = this.uniqueValidator(changed, null, change[2]);
                change[3] = changed;
            });
        }
    }

    componentDidMount() {
        window.onbeforeunload = () => {
            if (this.props.isEdited) {
                return "";
            }
        };
        this.staffReportDetails = this.props.actions.getStaffReportDetails(FIRM_ID);
        this.staffLookups = this.props.actions.fetchStaffLookupData(FIRM_ID);
        this.gracePeriodData = this.props.actions.getFirmGracePeriodDetails(FIRM_ID);
    }

    componentWillUnmount() {
        this.props.actions.clearAllUsers();
    }

    shouldComponentUpdate(nextProps, nextState) {

        //if (!nextProps.staffReportDetails.length) {
        //    return false;
        //}

        if (nextProps.isExport) {
            this.exportToExcel();
            return false;
        }
        if (nextProps.isClearFilters) {
            this.handleClearFilters();
            return false;
        }
        if (nextProps.isSortSelectedUsers) {
            this.sortSelectedUsersToTop();
        }
        return true;
    }
    async onSaveChanges() {

    }
    discardChangesYes() {

        const mySuccessNotification = {
            message: "Changes discarded successfully",
            type: NOTIFICATION_TYPE_SUCCESS,
            duration: 5000,
            canDismiss: true,
            showCloseAllBtn: true
        };
        this.disableHeaderCheckBox(false);
        this.props.actions.discardChanges();
        this.state.activatedUsersList = [];
        this.props.createNotification(mySuccessNotification);

    }

    renderRedirect = () => {
        let url = "oip://staff/staffmanager"
        window.open(url, "_self")
    };

    ShowConfirmationPopup = () => {
        this.setState({ showPopup: true });
    }

    closeConfirmationPopup = (returngcPd) => {
        this.setState({ showPopup: false });
        if (returngcPd == 0) {
            //window.location.reload(true);
            this.setState({ disableCompletebutton: true });
        }
    }

    clearFilters() {
        this.props.actions.clearAllFilters(true, this.props.staffReportDetails);

    }

    refreshGridData() {
        this.setState({ load: true })
        this.props.actions.getStaffReportDetails(
        ).then(() => {
            const mySuccessNotification = {
                message: "Grid successfully refreshed",
                type: NOTIFICATION_TYPE_SUCCESS,
                duration: 5000,
                canDismiss: true,
                showCloseAllBtn: true
            };
            this.setState({ load: false })
            this.props.createNotification(mySuccessNotification);
        });
    }

    showLoader(load) {
        return (
            <Dimmer page active={load} inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        );
    }

    handleClosemessage = () => {
        this.setState({ showLicenseError: false });
    }

    render() {
        return (
            <Fragment>
                <ConfirmationModal
                    firm={FIRM_ID}
                    showPopup={this.state.showPopup}
                    closePopup={this.closeConfirmationPopup}
                />
                {this.showLoader(this.state.load)}
                <Menu secondary className={this.props.reqClass}>
                    <Menu.Menu position="left">
                        <Menu.Item>
                            <span>
                                <Icon className='xcm-icon-alert-circle size-20 red' />
                            </span>
                            <span>
                                &nbsp;<b className='fs-18 color-wk-primary-red'>{this.props.staffLookups ? this.props.staffLookups.UnmatchedUsersCount : 0}</b>
                                &nbsp;<label>User Not Matched</label>
                            </span>
                        </Menu.Item>
                    </Menu.Menu>
                    <Menu.Menu position="right">
                        <Menu.Item>
                            <Button className="ui primary button" primary onClick={() => this.renderRedirect()}>
                                Staff Manager
                            </Button>
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
                <Fragment>
                    <HotTable
                        className="staffreporttable"
                        ref={this.hotTableComponent}
                        settings={this.settings}
                        data={this.props.staffReportDetails}
                        colHeaders={colHeaders}
                        colWidths={colWidths}
                        columns={this.columns}
                        beforeChange={this.onBeforeHotChange.bind(this)}
                        afterChange={this.afterChangeHandler.bind(this)}
                        afterFilter={this.afterFilterHandler.bind(this)}
                        afterLoadData={this.afterLoadDataHandler.bind(this)}
                        afterOnCellMouseDown={this.afterOnCellMouseDownHandler.bind(this)}
                        beforeKeyDown={event => {
                            if (event.keyCode === 46 || event.keyCode === 8) {
                                event.stopImmediatePropagation();
                            }
                        }}
                        width="100%"
                        height="calc(100vh - 185px)"
                    />
                    <Grid padded textAlign="right">
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign="left">

                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Fragment>
                <Menu secondary className={this.props.reqClass}>
                    <Menu.Menu position="right">
                        <Menu.Item>
                            <Button
                                className={`${((this.props.gracePeriodData.axcessIntegrationGracePeriod == 0) || this.state.disableCompletebutton) ? "wkbuttondisabled"
                                    : "ui primary button"
                                    }`}
                                onClick={() => this.ShowConfirmationPopup()}>Complete</Button>
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            </Fragment >
        );
    }
}
const mapStateToProps = state => {
    return {
        allUsers: state.userReducer.allUsers,
        isLoading: state.userReducer.isLoading,
        isEdited: state.userReducer.isEdited,
        isExport: state.userReducer.isExport,
        isClearFilters: state.userReducer.isClearFilters,
        createNotification: state.userReducer.createNotification,
        isSortSelectedUsers: state.userReducer.isSortSelectedUsers,
        staffReportDetails: state.userReducer.staffReportDetails,
        staffLookups: state.userReducer.staffLookupData,
        gracePeriodData: state.userReducer.firmGracePeriodData
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: config => {
        dispatch(createNotification(config));
    },
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(StaffLinkPageActions)
);
